export default "__VITE_ASSET__DDILReaV__"